import type { IRatingLeaderboardSlice, IRatingStore } from '~/modules/main'

const createLeaderboardSlice = (): IRatingLeaderboardSlice => ({
  entries: [],
  isLoading: false,
  isError: false,
  periods: { from: '', to: '' },
  currentUser: null,
})

export const state = (): IRatingStore => {
  return {
    current: createLeaderboardSlice(),
    previous: {
      ...createLeaderboardSlice(),
      modalTitle: '',
      modalText: '',
      currentUser: null,
    },
  }
}
